'use strict';
require('./main.scss')

//typical import
import {TweenLite, Power1} from "gsap";
import ScrollToPlugin from 'gsap/ScrollToPlugin'; //OK import


let actualSection = 1
let isScrolling = false;

let headerScrolled = false;

const getActualSection = () => {
    const sect = Math.round(window.scrollY / window.innerHeight) + 1
    return sect
}

const scrollHandler = (e) => {
    let newSection = getActualSection()
    if(newSection !== actualSection){
        actualSection = newSection
        const nowActive = document.querySelector(".leftNavigator__active")
        const nextActive = document.getElementById(`leftNavigator-${actualSection}`)
        if (!!nowActive){
            nowActive.classList.remove('leftNavigator__active')
        }
        if (!!nextActive){
            nextActive.classList.add('leftNavigator__active')
        }   
    }
}

const gotoSection = (e) => {
    e.preventDefault();
    const targetDiv = e.target.getAttribute('href')
    TweenLite.to(window, .8, {
        scrollTo:{
            y: targetDiv
        },
        ease: Power1.easeInOut
    });
}


const doOnLoad = () => {
    /*
    document.querySelectorAll('.menu-wrap .gotoElement').forEach((elem) => {
        elem.addEventListener('click', gotoSection, true)
    })
    window.addEventListener('scroll', scrollHandler, true);
    window.addEventListener("wheel", MouseWheelHandler, false);
    */
   myScrollHandler(null)
   window.addEventListener('scroll', myScrollHandler, true);
}

const myScrollHandler = (e) => {
    if(headerScrolled && window.scrollY > 0) return
    if(!headerScrolled && window.scrollY <= 0) return
    if(window.scrollY > 0){
        document.getElementById('main-header').classList.add('header-scrolled')
        headerScrolled = true;
    } else {
        document.getElementById('main-header').classList.remove('header-scrolled')
        headerScrolled = false;
    }
}


const MouseWheelHandler = (e) => {
    if(window.innerWidth > 1279) e.preventDefault();
    if(!isScrolling && window.innerWidth > 1279) {
        isScrolling = true
        var delta = e.deltaY < 0 ? -1 : 1
        const scrollTo = getActualSection() + delta
        const targetDiv = document.getElementById(`sezione-${scrollTo}`)
        if(!!targetDiv){
            TweenLite.to(window, .8, {
                scrollTo:{
                    y: targetDiv.offsetTop,
                    autoKill: false,
                },
                ease: Power1.easeInOut
            }).eventCallback('onComplete', () =>{
                resetScrollingFlag()
            });   
        } else {
            resetScrollingFlag()
        }
    }
}

const resetScrollingFlag = () => {
    setTimeout(()=>{isScrolling = false}, 600)
}

window.onload = doOnLoad;












// WEBPACK FOOTER //
// ./src/main.js